import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  defaultDialogState,
  setCurrentDialogSettings,
  setDefaultDialogSettings,
  setDialogOpen,
} from '../redux/slices/confirmSlice';
import { DialogSettingsOptions } from '../types/confirm';

// eslint-disable-next-line @typescript-eslint/no-empty-function
let resolveCallback = (b: boolean): void => {};

const useConfirm = () => {
  const dispatch = useDispatch();

  const onConfirm = useCallback(() => {
    dispatch(setDialogOpen(false));
    resolveCallback(true);
  }, [dispatch]);

  const onCancel = useCallback(() => {
    dispatch(setDialogOpen(false));
    // dispatch(setDefaultDialogSettings());
    resolveCallback(false);
  }, [dispatch]);

  const confirm = useCallback(
    (settings: DialogSettingsOptions) => {
      dispatch(setDialogOpen(true));
      dispatch(setDefaultDialogSettings());
      dispatch(setCurrentDialogSettings({ ...defaultDialogState.dialogState, ...settings }));

      return new Promise<boolean>((res) => {
        resolveCallback = res;
      });
    },
    [dispatch]
  );

  return { confirm, onConfirm, onCancel };
};

export default useConfirm;
